import { PLATFORM_COURSES } from '../config/courses';

/**
 * Tudo o que a aplicação guarda no navegador sai no logout — é o que a Política
 * de Privacidade promete (cl. 2.8 e 11.2), e a última aula ou o último filtro de
 * uma conta não devem aparecer para a próxima pessoa no mesmo aparelho.
 *
 * Por PREFIXO, e não por uma lista de chaves, para que o núcleo não precise
 * importar código de curso:
 *  - `neurodidatica_` — sessão (token e perfil) e a última aula de cada curso
 *    (utils/lastLesson.ts);
 *  - `<slug>:` — o que um curso guarda para si. A convenção já é seguida por
 *    `radiologia-r1:qbank:last-config:v1` (banco de questões), e um curso novo
 *    que a siga sai daqui sem tocar neste arquivo.
 */
const APP_PREFIX = 'neurodidatica_';

/**
 * Chaves de telas antigas que nada mais monta, mas que um navegador pode ainda
 * carregar de quando elas existiam — e as do shell anterior, que o boot já
 * apaga (utils/legacyShell.ts). Saem também, pela mesma promessa.
 */
const LEGACY_KEYS = [
  'question_blocks',
  'error_notebook_cards',
  'banco_questoes_personalizado',
  'history_sessions',
  'surprise_cards',
  'medverse_shell',
  'medverse_pending_topic',
];

function pertenceAoApp(key: string): boolean {
  return (
    key.startsWith(APP_PREFIX) ||
    PLATFORM_COURSES.some((course) => key.startsWith(`${course.slug}:`)) ||
    LEGACY_KEYS.includes(key)
  );
}

/**
 * Apaga do armazenamento local tudo o que é da aplicação, e só isso — o que
 * terceiros guardam no mesmo domínio (ex.: a sessão de replay do Sentry) segue
 * as regras deles (Política, cl. 11.3).
 *
 * As chaves são coletadas ANTES de remover: apagar durante a varredura por
 * índice pularia a vizinha de cada chave removida.
 */
export function forgetAppBrowserData(
  storage: Storage | undefined = globalThis.localStorage,
): void {
  if (!storage) return;

  try {
    const chaves: string[] = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key !== null && pertenceAoApp(key)) chaves.push(key);
    }
    chaves.forEach((key) => storage.removeItem(key));
  } catch {
    // Armazenamento indisponível (modo privado, cota): não há o que apagar, e o
    // logout não pode falhar por isso.
  }
}
